<template>
  <v-container fluid class="fc-root px-1 pt-0 pb-3">

    <div class="fc-row fc-row--kpi">

      <Card v-for="card in kpiCardsList" :key="card.id" class="fc-kpi-card primary" :class="card.sizeClass">
        <div class="fc-kpi-body">
          <div class="fc-kpi-section-label accent--text">
            <v-icon size="13" class="mr-1">{{ card.icon }}</v-icon>
            {{ $t(card.title) }}
          </div>

          <div class="fc-wx-main" v-if="card.type === 'weather-main'">
            <img src="../assets/weather.png" class="fc-weather-img" />
            <div>
              <div class="fc-wx-temp">
                <span :class="card.data.value !== 'N/A' ? 'number--text' : 'error--text'">
                  {{ card.data.value }}
                </span>
                <span class="fc-gen-unit-large extraGrey--text" v-if="card.data.unit">
                  {{ card.data.unit }}
                </span>
              </div>
              <div class="fc-wx-cond extraGrey--text">
                {{ card.condition }}
              </div>
            </div>
          </div>

          <div :class="card.isEnergy ? 'fc-gen-value-large' : 'fc-cond-value-large'" v-else>
            <span :class="card.data.value !== 'N/A' ? 'number--text' : 'error--text'">
              {{ card.data.value }}
            </span>
            <span class="fc-gen-unit-large extraGrey--text" v-if="card.data.unit">
              {{ card.data.unit }}
            </span>
          </div>
        </div>
      </Card>

      <!-- Penalty Trend is commented out 
        <Card class="fc-kpi-card primary">
            <div class="fc-kpi-body">
                <div class="fc-kpi-section-label accent--text">
                    <v-icon size="13" class="mr-1">trending_up</v-icon>
                    {{ $t("Penalty Trend") }}
                </div>
                <div class="fc-pen-grid">
                    <div class="fc-pen-item">
                        <div class="fc-pen-label extraGrey--text">{{ $t("Today") }}</div>
                        <div class="fc-pen-value" :class="penaltyTrend['Today'] !== undefined ? 'number--text' : 'error--text'">
                            {{ penaltyTrend["Today"] !== undefined ? penaltyTrend["Today"] : "N/A" }}
                        </div>
                        <div class="fc-pen-unit extraGrey--text" v-if="penaltyTrend['Today'] !== undefined">INR</div>
                    </div>
                    <div class="fc-pen-item">
                        <div class="fc-pen-label extraGrey--text">{{ $t("Yesterday") }}</div>
                        <div class="fc-pen-value" :class="penaltyTrend['Yesterday'] !== undefined ? 'number--text' : 'error--text'">
                            {{ penaltyTrend["Yesterday"] !== undefined ? penaltyTrend["Yesterday"] : "N/A" }}
                        </div>
                        <div class="fc-pen-unit extraGrey--text" v-if="penaltyTrend['Yesterday'] !== undefined">INR</div>
                    </div>
                    <div class="fc-pen-item">
                        <div class="fc-pen-label extraGrey--text">{{ $t("Trend") }}</div>
                        <div class="fc-pen-trend">
                            <v-icon size="18" :color="penaltyTrend['Trend'] == 'UP' ? 'error' : (penaltyTrend['Trend'] ? 'success' : '')">
                                {{ penaltyTrend["Trend"] == "UP" ? "arrow_upward" : penaltyTrend["Trend"] ? "arrow_downward" : "" }}
                            </v-icon>
                            <span :class="penaltyTrend['Diff'] !== undefined ? 'number--text' : 'error--text'">
                                {{ penaltyTrend["Diff"] !== undefined ? penaltyTrend["Diff"] : "N/A" }}
                            </span>
                            <span class="fc-pen-unit extraGrey--text" v-if="penaltyTrend['Diff'] !== undefined">INR</span>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
        -->

    </div>

    <div class="fc-row fc-row--charts">

      <Card class="fc-chart-card primary fc-premium-card">
        <div class="fc-card-header fc-premium-card-header">
          <div class="fc-card-title-group">
            <div class="fc-card-title primaryText--text scada-title-premium">{{ $t("ACTUAL DATA VS FORECASTED DATA") }}
            </div>
            <div class="fc-card-subtitle extraGrey--text scada-subtitle-premium">{{ $t("Data comparison for actual energy generated vs forecasted energy generated") }}</div>
          </div>
          <div class="fc-card-controls fc-premium-controls">
            <Toggle :modelValue="currentView" :theme="theme" @toggleValueChange="(val) => (currentView = val)"
              class="fc-custom-toggle">
              <v-btn flat value="graph" class="scada-toggle-height fc-toggle-btn">
                <v-icon class="mr-1" size="18">show_chart</v-icon>
                <span class="scada-btn-font">{{ $t("Graph") }}</span>
              </v-btn>
              <v-btn flat value="table" class="scada-toggle-height fc-toggle-btn">
                <v-icon class="mr-1" size="18">table_chart</v-icon>
                <span class="scada-btn-font">{{ $t("Table") }}</span>
              </v-btn>
            </Toggle>
            <div class="fc-controls-divider"></div>
            <v-select :items="models" v-model="graphModel"
              :menu-props="{ offsetY: true, nudgeBottom: 4, overflowY: true, contentClass: 'fc-model-dropdown-menu' }"
              dense outlined hide-details color="white" class="fc-model-select">
              <template v-slot:prepend-inner>
                <v-icon size="18" color="number" class="mr-2 mt-1">mdi-cube-outline</v-icon>
              </template>
            </v-select>
          </div>
        </div>
        <div v-show="currentView == 'graph'" class="fc-graph-body fc-premium-graph-body">
          <GlobalGraph v-if="series.length" :series="series" :xAxisData="xAxis" :yAxis="yAxis" :theme="theme"
            :legendPosition="legend" :grid="[{ left: 30, right: 20, bottom: 90, top: 40, containLabel: true }]"
            :toolBoxPosition="{ top: 0, right: 10, itemGap: 16 }" :dataZoomConfig="{ height: 20, bottom: 30 }"
            class="fc-graph fc-premium-graph" />
          <div v-else class="fc-empty error--text">N/A</div>
        </div>
        <div v-if="currentView == 'table'" class="fc-table-body fc-premium-table-body"
          :style="{ maxHeight: tableHeight, overflowY: 'auto' }">
          <div class="fc-table-download-btn">
            <TableButtons :isReload="false" :isEmit="true" @download:report="() => download()" />
          </div>
          <v-data-table v-if="forecastTableData.length" :items="forecastTableData" :headers="forecastTableHeader"
            hide-actions :pagination="{ rowsPerPage: -1 }" class="elevation-1 fc-premium-v-table">
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.time }}</td>
                <td>
                  <span v-if="props.item.actual == null || props.item.actual === ''" class="error--text" style="font-weight: 600;">NULL</span>
                  <span v-else class="number--text">{{ props.item.actual }}</span>
                </td>
                <td>
                  <span v-if="props.item.forecast == null || props.item.forecast === ''" class="error--text" style="font-weight: 600;">NULL</span>
                  <span v-else class="number--text">{{ props.item.forecast }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </Card>

      <Card class="fc-donut-card primary">
        <div class="fc-card-header">
          <div class="fc-card-title-group">
            <div class="fc-card-title primaryText--text">{{ pieView == 'dev' ? $t("Range and Deviation") :
              $t("Revision") }}</div>
            <div class="fc-card-subtitle extraGrey--text">{{ $t("Deviation and Revision data") }}</div>
          </div>
          <Toggle :modelValue="pieView" :theme="theme" @toggleValueChange="(val) => (pieView = val)"
            class="fc-custom-toggle">
            <v-btn class="scada-toggle-height fc-toggle-btn" flat value="dev">
              <span class="scada-btn-font">{{ $t("Deviation") }}</span>
            </v-btn>
            <v-btn class="scada-toggle-height fc-toggle-btn" flat value="rev">
              <span class="scada-btn-font">{{ $t("Revision") }}</span>
            </v-btn>
          </Toggle>
        </div>
        <div v-show="pieView == 'dev'" class="fc-pie-body">
          <GlobalGraph class="fc-pie-graph" :isMagicType="false" :series="[{
            name: $t('Range and Deviation'),
            center: ['50%', '50%'],
            bottom: '5%',
            type: 'pie',
            radius: ['40%', '75%'],
            avoidLabelOverlap: false,
            itemStyle: { borderRadius: 10, borderColor: $vuetify.theme.primaryText, borderWidth: 1 },
            data: pieData,
          }]" :isHoverFix="false" :legendPosition="legend" :theme="theme" />
        </div>
        <div v-if="pieView == 'rev'" class="fc-rev-list">
          <template v-if="items.length">
            <Card class="fc-rev-item primary" v-for="item in items" :key="`${item.revisionNo}-${item.date}`">
              <div class="fc-rev-top">
                <span class="number--text font-weight-bold">R-{{ item.revisionNo }}</span>
                <span class="extraGrey--text fc-rev-date">{{ item.date }}</span>
              </div>
              <div class="fc-rev-body primaryText--text">
                <div><span class="extraGrey--text">{{ $t("Generation") }}:</span> {{ item.generation }}</div>
                <div><span class="extraGrey--text">{{ $t("Reason") }}:</span> {{ item.reason }}</div>
                <div><span class="extraGrey--text">{{ $t("Remarks") }}:</span> {{ item.remarks }}</div>
              </div>
            </Card>
          </template>
          <div v-else class="fc-premium-empty" style="margin: auto;">
            <div class="fc-empty-icon-wrapper">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" class="fc-empty-icon">
                <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
                <path d="M3 12A9 3 0 0 0 21 12"></path>
                <line x1="15" y1="15" x2="21" y2="21"></line>
                <line x1="21" y1="15" x2="15" y2="21"></line>
              </svg>
            </div>
            <div class="fc-empty-title">{{ $t("No Data Available") }}</div>
            <div class="fc-empty-subtitle">{{ $t("No records found for the selected time range.") }}</div>
          </div>
        </div>
      </Card>

    </div>

    <div class="fc-row fc-row--bottom">

      <Card class="fc-bottom-card primary">
        <div class="fc-card-header">
          <div class="fc-card-title-group">
            <div class="fc-card-title primaryText--text">{{ $t("Trend Table") }}</div>
            <div class="fc-card-subtitle extraGrey--text">{{ $t("Generation/weather parameters trend") }}</div>
          </div>
        </div>
        <table class="fc-table" v-if="Object.keys(summary).length">
          <thead>
            <tr>
              <th class="extraGrey--text">{{ $t("Parameters") }}</th>
              <th class="extraGrey--text">{{ $t("Actual") }}</th>
              <th class="extraGrey--text">{{ $t("Forecast") }}</th>
              <th class="extraGrey--text">{{ $t("Trend") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in Object.keys(summary)" :key="p">
              <td class="primaryText--text">{{ p }}</td>
              <td
                :class="(summary[p]['actual'] == null || summary[p]['actual'] == 'No Data') ? 'error--text' : 'number--text'">
                {{ summary[p]["actual"] != null ? summary[p]["actual"] : "N/A" }}
              </td>
              <td
                :class="(summary[p]['forecast'] == null || summary[p]['forecast'] == 'No Data') ? 'error--text' : 'number--text'">
                {{ summary[p]["forecast"] != null ? summary[p]["forecast"] : "N/A" }}
              </td>
              <td>
                <div class="fc-trend-cell">
                  <v-icon size="14"
                    :color="summary[p]['trend'] == 'UP' ? 'success' : (summary[p]['trend'] ? 'error' : '')">
                    {{ summary[p]["trend"] == "UP" ? "arrow_upward" : summary[p]["trend"] ? "arrow_downward" : "" }}
                  </v-icon>
                  <span
                    :class="(summary[p]['trendValue'] == null || summary[p]['trendValue'] == 'No Data') ? 'error--text' : 'number--text'">
                    {{ summary[p]["trendValue"] != null ? summary[p]["trendValue"] : "N/A" }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="fc-empty error--text">N/A</div>
      </Card>

      <Card class="fc-bottom-card primary">
        <div class="fc-card-header">
          <div class="fc-card-title-group">
            <div class="fc-card-title primaryText--text">{{ $t("Energy vs Penalty") }}</div>
            <div class="fc-card-subtitle extraGrey--text">{{ $t("Data compared to deviation range") }}</div>
          </div>
        </div>
        <table class="fc-table" v-if="Object.keys(penalty.details).length">
          <thead>
            <tr>
              <th class="extraGrey--text">{{ $t("Range") }} (%)</th>
              <th class="extraGrey--text">{{ $t("Generation") }} (kWh)</th>
              <th class="extraGrey--text">{{ $t("Penalty") }} (INR)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(p, index) in Object.keys(penalty.details)" :key="`${p}-${index}`">
              <td class="primaryText--text">{{ p }}</td>
              <td :class="penalty.details[p].gen ? 'number--text' : 'error--text'">
                {{ penalty.details[p].gen != null ? penalty.details[p].gen.toFixed(2) : "N/A" }}
              </td>
              <td :class="penalty.details[p].penalty ? 'number--text' : 'error--text'">
                {{ penalty.details[p].penalty != null ? penalty.details[p].penalty.toFixed(2) : "N/A" }}
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="fc-premium-empty">
          <div class="fc-empty-icon-wrapper">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" class="fc-empty-icon">
              <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
              <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
              <path d="M3 12A9 3 0 0 0 21 12"></path>
              <line x1="15" y1="15" x2="21" y2="21"></line>
              <line x1="21" y1="15" x2="15" y2="21"></line>
            </svg>
          </div>
          <div class="fc-empty-title">{{ $t("No Data Available") }}</div>
          <div class="fc-empty-subtitle">{{ $t("No records found for the selected time range.") }}</div>
        </div>
      </Card>

    </div>

    <v-btn @click="() => (dialog = true)" fixed right bottom fab color="accent" class="hidden-xs-only fc-fab-premium">
      <v-icon color="white">mdi-plus</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="700px" content-class="fc-premium-dialog">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="fc-dialog-card primary" dark>

          <v-card-title class="fc-dialog-header">
            <span class="fc-dialog-title">{{ $t("Add Revision") }} &ndash; {{ plantName }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false" class="fc-dialog-close" :ripple="false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="fc-dialog-content">
            <v-container grid-list-xl class="pa-0">

              <v-layout wrap class="fc-dialog-inputs">
                <v-flex xs4>
                  <div class="fc-input-label">{{ $t('REVISION ID') }}</div>
                  <v-text-field v-model="newRevisionId" disabled outlined dense hide-details
                    class="fc-input-field fc-disabled-input" />
                </v-flex>
                <v-flex xs4>
                  <div class="fc-input-label">{{ $t('REASON') }}</div>
                  <v-select :items="['Curtailment', 'Grid Outage', 'Internal Plant', 'Weather Variation']"
                    v-model="reason" :placeholder="$t('Select reason')" outlined dense hide-details
                    :rules="[(v) => !!v || $t('This field is required')]" class="fc-input-field"
                    :menu-props="{ bottom: true, offsetY: true }" />
                </v-flex>
                <v-flex xs4>
                  <div class="fc-input-label">{{ $t('REMARKS') }}</div>
                  <v-text-field :placeholder="$t('Any comments')" v-model="remarks" outlined dense hide-details
                    :rules="[(v) => !!v || $t('This field is required')]" class="fc-input-field" />
                </v-flex>
              </v-layout>

              <div class="fc-dialog-table-wrapper mt-4">
                <table class="fc-dialog-table">
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 30%;">{{ $t('PREVIOUS REVISION') }}</th>
                      <th class="text-center" style="width: 30%;">{{ $t('TIME') }}</th>
                      <th class="text-center" style="width: 40%;">{{ $t('FORECAST GEN (MWH)') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in dialogData" :key="index">
                      <td class="text-left text-muted">{{ item.revision_id }}</td>
                      <td class="text-center text-muted">{{ item.time }}</td>
                      <td class="text-center">
                        <v-text-field class="fc-table-input" v-model="item.forecast_gen" outlined dense hide-details
                          @change="(val) => generationChangeHandler(val, item.time)" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-container>
          </v-card-text>

          <v-card-actions class="fc-dialog-actions">
            <v-spacer />
            <v-btn flat class="fc-btn-cancel" @click="dialog = false" :ripple="false">
              {{ $t("Cancel") }}
            </v-btn>
            <v-btn class="fc-btn-submit" @click="addRevisionHandler" :disabled="!valid" :ripple="false">
              {{ $t("Submit") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </v-container>
</template>

<script>
const momentTz = require('moment-timezone');
import moment from "moment";
import ForecastService from "@/services/Forecast.js";
import {
  mapGetters,
  mapMutations
} from "vuex";
import {
  mapGettersMixin
} from "@/util/mixin/index";
import GlobalGraph from "@/components/common/GlobalGraph";
import TableButtons from "@/components/CustomReport/TableButtons";

export default {
  components: {
    GlobalGraph,
    TableButtons,
  },
  mixins: [mapGettersMixin],
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      fab: false,
      showTooltip: false,
      dialog: false,
      currentView: "graph",
      pieView: "dev",
      graphModel: "Model-1",
      dialogData: [],
      penalty: {
        total: null,
        details: {},
      },
      penaltyTrend: {
        Today: null,
        Yesterday: null,
        Diff: null,
        Trend: "",
      },
      summary: {},
      series: [],
      xAxis: [],
      yAxis: [{
        type: "value",
        name: "Generation (kWh)",
        min: 0,
        position: "left",
        axisLabel: {
          color: this.$vuetify.theme.primaryText,
        },
        nameTextStyle: {
          color: this.$vuetify.theme.primaryText,
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: this.$vuetify.theme.primaryText,
          },
        },
      },],
      forecastTableData: [],
      items: [],
      pieData: [],
      models: [
        "Model-1",
        "Model-2"
      ],
      legend: {
        left: "center",
        orient: "horizontal",
        bottom: 60,
      },
      actualTotalGen: null,
      forecastedTotalGen: null,
      weatherData: {
        "Wind Speed": null,
        Temperature: null,
        Humidity: null,
        Irradiance: null,
        "Wind Direction": null,
        Condition: "",
      },
      plantName: "",
      revisedGen: {},
      newRevisionId: "R-0",
      reason: "",
      remarks: "",
      dateFrom: "",
      dateTo: "",
      valid: false,
      enableWatch: false,
      filter: [{
        id: "selectedRange",
        type: "select",
        title: "Choose Date Range",
        value: [{
          interval: "daily",
          startOffset: 0,
          endOffset: 0,
          format: "minute",
          text: "Today",
        },
        {
          interval: "daily",
          startOffset: 1,
          endOffset: 1,
          format: "minute",
          text: "Yesterday",
        },
        {
          interval: "daily",
          startOffset: 2,
          endOffset: 0,
          format: "daily",
          text: "Last 3 days",
        },
        {
          interval: "daily",
          startOffset: 6,
          endOffset: 0,
          format: "daily",
          text: "Last 7 days",
        },
        {
          interval: "daily",
          startOffset: 29,
          endOffset: 0,
          format: "daily",
          text: "Last 30 days",
        },
        {
          interval: "daily",
          offsetLevel: "month",
          startOffset: 0,
          endOffset: 0,
          format: "daily",
          text: "Present month",
        },
        {
          interval: "daily",
          offsetLevel: "month",
          startOffset: 1,
          endOffset: 1,
          format: "daily",
          text: "Last month",
        },
        {
          interval: "monthly",
          offsetLevel: "month",
          startOffset: 2,
          endOffset: 0,
          format: "monthly",
          text: "Last 3 months",
        },
        {
          interval: "monthly",
          offsetLevel: "year",
          startOffset: 0,
          endOffset: 0,
          format: "monthly",
          text: "Present Year",
        },
        {
          interval: "monthly",
          offsetLevel: "year",
          startOffset: 1,
          endOffset: 1,
          format: "monthly",
          text: "Last Year",
        },
        {
          interval: "custom",
          text: "Custom",
        },
        ],
      },
      {
        ref: "selectedRange",
        id: "Date",
        type: "datePicker",
        title: "Select Date Range",
        condition: (ref) => {
          if (ref.text === "Custom") {
            return true;
          } else {
            return false;
          }
        },
      },
      ],
      activeFilter: {},
    };
  },
  computed: {
    kpiCardsList() {
      return [
        {
          id: 'next-hour',
          type: 'weather-main',
          title: 'Next hour forecast',
          icon: 'wb_sunny',
          sizeClass: 'fc-kpi-large',
          isEnergy: false,
          data: this.splitValueAndUnit(this.weatherData['Temperature']),
          condition: this.weatherData['Condition'] ? this.$t(this.weatherData['Condition'].toLowerCase()) : '',
        },
        {
          id: 'irradiance',
          type: 'generic-kpi',
          title: 'Irradiance',
          icon: 'wb_incandescent',
          sizeClass: 'fc-kpi-small',
          isEnergy: false,
          data: this.splitValueAndUnit(this.weatherData['Irradiance']),
        },
        {
          id: 'humidity',
          type: 'generic-kpi',
          title: 'Humidity',
          icon: 'water_drop',
          sizeClass: 'fc-kpi-small',
          isEnergy: false,
          data: this.splitValueAndUnit(this.weatherData['Humidity']),
        },
        {
          id: 'wind-speed',
          type: 'generic-kpi',
          title: 'Wind Speed',
          icon: 'air',
          sizeClass: 'fc-kpi-small',
          isEnergy: false,
          data: this.splitValueAndUnit(this.weatherData['Wind Speed']),
        },
        {
          id: 'wind-dir',
          type: 'generic-kpi',
          title: 'Wind Direction',
          icon: 'explore',
          sizeClass: 'fc-kpi-small',
          isEnergy: false,
          data: this.splitValueAndUnit(this.weatherData['Wind Direction']),
        },
        {
          id: 'actual-energy',
          type: 'generic-kpi',
          title: 'Actual Energy',
          icon: 'bolt',
          sizeClass: '',
          isEnergy: true,
          data: {
            value: this.actualTotalGen ? this.actualTotalGen : 'N/A',
            unit: this.actualTotalGen ? 'kWh' : ''
          },
        },
        {
          id: 'forecast-energy',
          type: 'generic-kpi',
          title: 'Forecasted Energy',
          icon: 'bolt',
          sizeClass: '',
          isEnergy: true,
          data: {
            value: this.forecastedTotalGen ? this.forecastedTotalGen : 'N/A',
            unit: this.forecastedTotalGen ? 'kWh' : ''
          },
        }
      ];
    },
    ...mapGetters(["getGeneralState", "getPlantName", "getSelectedPlantId", "getActivePlantTimezone"]),
    currentLanguage() {
      return this.getGeneralState("language");
    },
    activeWatch() {
      return `${this.dateFrom} ${this.dateTo}`;
    },
    watchDates() {
      return this.activeFilter.Date ?
        `${this.activeFilter.Date.from} ${this.activeFilter.Date.to}` :
        null;
    },
    tableHeight() {
      const screenResWidth = window.screen.width * window.devicePixelRatio;
      if (screenResWidth <= 2544 && screenResWidth >= 1584) {
        return "59vh";
      } else if (screenResWidth <= 1584 && screenResWidth >= 1394) {
        return "56vh";
      } else {
        return "54vh";
      }
    },
    dialogHeader() {
      return [{
        text: this.$t("Previous Revision Id"),
        align: "center",
        value: "revision_id",
        sortable: true,
      },
      {
        text: this.$t("Time"),
        align: "center",
        value: "time",
        sortable: true,
      },
      {
        text: this.$t("Forecast Generation (MWh)"),
        align: "center",
        value: "forecast_gen",
        sortable: true,
      },
      ];
    },
    forecastTableHeader() {
      return [{
        text: this.$t("Time"),
        value: "time",
        align: "left",
        width: "33%",
        sortable: false,
      },
      {
        text: this.$t("Actual"),
        value: "actual",
        align: "left",
        width: "33%",
        sortable: false,
      },
      {
        text: this.$t("Forecast"),
        value: "forecast",
        align: "left",
        width: "34%",
        sortable: false,
      },
      ];
    },
  },
  async mounted() {
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if ((child.condition && (!!child.considerStateAlways || child.condition(Obj[child.ref]))) || !child.condition) {
        if (child.type === 'select') {
          if (typeof child.value === 'function') {
            Obj[child.id] = child.value(Obj[child.ref])
          } else {
            Obj[child.id] = child.value[0]
          }
        } else if (child.type === 'datePicker' || child.type === 'singleDatePicker') {
          let parameters = ['from', 'to']
          parameters.forEach(key => {
            if (!Obj[child.id]) {
              Obj[child.id] = {}
            }
            Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
          })
        } else {
          Obj[child.id] = child.value
        }
      }
    })
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)

    this.SET_PROGRESS_BAR(true);
    await this.setIntervalWithoutDelay(this.initialCall, 3600000);
    this.SET_PROGRESS_BAR(false);
  },
  methods: {
    ...mapMutations([
      "SET_PROGRESS_BAR",
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT"
    ]),
    splitValueAndUnit(val) {
      if (!val) return { value: "N/A", unit: "" };
      const str = val.toString().trim();
      const match = str.match(/^([\d.]+)\s*(.*)$/);
      if (match) {
        return { value: match[1], unit: match[2] };
      }
      return { value: str, unit: "" };
    },
    activateTooltip() {
      setTimeout(() => {
        this.showTooltip = !this.showTooltip;
      }, 500);
    },
    async initialCall() {
      if (this.activeFilter.selectedRange.text !== "Custom") {
        let param = this.computeParam();
        this.dateFrom = param.from;
        this.dateTo = param.to;
      }

      try {
        // Fetch basic total generation for both models to find the most accurate one
        const [res1, res2] = await Promise.all([
          ForecastService.getTotalGeneration(this.getSelectedPlantId, "Model-1"),
          ForecastService.getTotalGeneration(this.getSelectedPlantId, "Model-2")
        ]);

        const act1 = res1.data.message["Actual Gen"] || 0;
        const fcst1 = res1.data.message["Forecasted Gen"] || 0;
        const diff1 = Math.abs(act1 - fcst1);

        const act2 = res2.data.message["Actual Gen"] || 0;
        const fcst2 = res2.data.message["Forecasted Gen"] || 0;
        const diff2 = Math.abs(act2 - fcst2);

        this.graphModel = diff2 < diff1 ? "Model-2" : "Model-1";
      } catch (error) {
        console.error("Failed to determine best model:", error);
      }

      await Promise.all([
        this.totalGenHandler(),
        this.weatherDataHandler(),
        // this.penaltyTrendHandler(),
        this.revisionCardHandler(),
        this.lineGraphHandler(),
        this.deviationGraphHandler(),
        this.penaltyVsGenHandler(),
        this.summaryHandler(),
      ]);
      this.enableWatch = true;
      this.plantName = this.getPlantName(this.getSelectedPlantId);
    },
    computeParam() {
      const tz = this.getActivePlantTimezone;
      const param = {};
      param["type"] = this.activeFilter["selectedRange"].interval;
      if (this.activeFilter["selectedRange"].interval === "daily") {
        if (this.activeFilter["selectedRange"].offsetLevel === "month") {
          param.from = momentTz().tz(tz)
            .subtract(
              this.activeFilter["selectedRange"].startOffset,
              this.activeFilter["selectedRange"].offsetLevel
            )
            .startOf(this.activeFilter["selectedRange"].offsetLevel)
            .format("YYYY-MM-DD");
          param.to = momentTz().tz(tz)
            .subtract(
              this.activeFilter["selectedRange"].endOffset,
              this.activeFilter["selectedRange"].offsetLevel
            )
            .endOf(this.activeFilter["selectedRange"].offsetLevel)
            .format("YYYY-MM-DD");
        } else {
          param.from = momentTz().tz(tz)
            .subtract(this.activeFilter["selectedRange"].startOffset, "day")
            .format("YYYY-MM-DD");
          param.to = momentTz().tz(tz)
            .subtract(this.activeFilter["selectedRange"].endOffset, "day")
            .format("YYYY-MM-DD");
        }
      } else if (this.activeFilter["selectedRange"].interval === "monthly") {
        let format = "YYYY-MM-DD";
        param.from = momentTz().tz(tz)
          .subtract(
            this.activeFilter["selectedRange"].startOffset,
            this.activeFilter["selectedRange"].offsetLevel
          )
          .startOf(this.activeFilter["selectedRange"].offsetLevel)
          .format(`${format}`);
        param.to = momentTz().tz(tz)
          .subtract(
            this.activeFilter["selectedRange"].endOffset,
            this.activeFilter["selectedRange"].offsetLevel
          )
          .endOf(this.activeFilter["selectedRange"].offsetLevel)
          .format(`${format}`);
      }
      return param;
    },
    async totalGenHandler() {
      try {
        const response = await ForecastService.getTotalGeneration(
          this.getSelectedPlantId,
          this.graphModel
        );
        this.actualTotalGen = response.data.message["Actual Gen"];
        this.forecastedTotalGen = response.data.message["Forecasted Gen"];
      } catch (error) {
        this.actualTotalGen = null;
        this.forecastedTotalGen = null;
        console.log(error, "ERROR");
      }
    },
    async weatherDataHandler() {
      try {
        const response = await ForecastService.getWeatherData(
          this.getSelectedPlantId
        );
        this.weatherData = response.data.message;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    async penaltyTrendHandler() {
      try {
        const response = await ForecastService.getPenaltyTrendData(
          this.getSelectedPlantId
        );
        this.penaltyTrend = response.data.message;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    async lineGraphHandler() {
      try {
        this.series = [];
        this.forecastTableData = [];
        this.xAxis = [];
        const response = await ForecastService.getGraphData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo,
          this.graphModel
        );
        let graphType = "line";
        if (!moment(this.dateFrom).isSame(this.dateTo, "day")) {
          graphType = "bar";
        }
        const actualObj = {
          name: this.$t("Actual"),
          type: graphType,
          smooth: true,
          symbol: "circle",
          symbolSize: 6,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: this.$vuetify.theme.actualTop
              }, {
                offset: 1,
                color: this.$vuetify.theme.actualBottom
              }]
            }
          },
          data: [],
        };
        const forecastObj = {
          name: this.$t("Forecasted"),
          type: graphType,
          smooth: true,
          symbol: "circle",
          symbolSize: 6,
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: this.$vuetify.theme.forecastTop
              }, {
                offset: 1,
                color: this.$vuetify.theme.forecastBottom
              }]
            }
          },
          data: [],
        };
        response.data.message.forEach((el) => {
          const tableData = {
            time: el.time,
            forecast: el.forecast,
            actual: el.actual,
          };
          const revisionObj = {
            revision_id: el.revisionId,
            time: el.time,
            forecast_gen: el.forecast,
          };
          this.dialogData.push(revisionObj);
          forecastObj.data.push(el.forecast);
          actualObj.data.push(el.actual);
          this.forecastTableData.push(tableData);
          this.xAxis.push(el.time);
        });
        this.series.push(...[actualObj, forecastObj]);
      } catch (error) {
        this.forecastTableData = [];
        this.series = [];
        this.xAxis = [];
        console.log(error, "ERROR");
      }
    },
    async summaryHandler() {
      try {
        const response = await ForecastService.getSummaryData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo,
          this.graphModel
        );
        this.summary = response.data.message;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    async deviationGraphHandler() {
      try {
        let pieValue = [];
        const response = await ForecastService.getDeviationCountData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo,
          this.graphModel
        );
        Object.keys(response.data.message[0]).forEach((key) => {
          let newObj = {};
          newObj["value"] =
            response.data.message[0][key] == null ||
              response.data.message[0][key] == undefined ?
              0 :
              response.data.message[0][key];
          newObj["name"] = key;
          pieValue.push(newObj);
        });
        this.pieData = pieValue;
      } catch (error) {
        this.pieData = [];
        console.log(error, "ERROR");
      }
    },
    async penaltyVsGenHandler() {
      try {
        const response = await await ForecastService.getPenaltyVsGenerationData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo
        );
        this.penalty.details = response.data.message;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    async revisionCardHandler() {
      try {
        const response = await ForecastService.getRevisionData(
          this.getSelectedPlantId,
          this.dateFrom,
          this.dateTo
        );
        let tempRevision = 0;
        this.items = response.data.message.map((el) => {
          if (tempRevision < el["revisionNo"]) {
            tempRevision = el["revisionNo"];
          }
          el["date"] = momentTz(el["date"]).tz(this.getActivePlantTimezone).format("YYYY-MM-DD HH:mm:ss");
          return el;
        });
        this.newRevisionId = `R-${tempRevision + 1}`;
      } catch (error) {
        console.log(error, "ERROR");
      }
    },
    generationChangeHandler(val, time) {
      this.$set(this.revisedGen, time, val);
    },
    async addRevisionHandler() {
      if (this.$refs.form.validate()) {
        if (Object.keys(this.revisedGen).length > 0) {
          try {
            this.SET_PROGRESS_BAR(true);
            const revisionNo = this.newRevisionId.split("-")[1];
            const payload = {
              revisionId: revisionNo,
              revisionNo: revisionNo,
              plantId: this.getSelectedPlantId,
              date: momentTz().tz(this.getActivePlantTimezone).format("YYYY-MM-DD"),
              reason: this.reason,
              remarks: this.remarks,
              revisedData: this.revisedGen,
            };
            const response = await ForecastService.postRevision(payload);
            if (response.status == 200) {
              Object.keys(this.revisedGen).forEach((timeRevised) => {
                const dialogIndex = this.dialogData.findIndex(
                  (item) => timeRevised == item.time
                );
                if (dialogIndex >= 0) {
                  this.$set(
                    this.dialogData[dialogIndex],
                    "revision_id",
                    payload["revisionId"]
                  );
                }
                const itemObj = {};
                itemObj["revisionNo"] = payload["revisionId"];
                itemObj["generation"] = this.revisedGen[timeRevised];
                itemObj["reason"] = payload["reason"];
                itemObj["remarks"] = payload["remarks"];
                itemObj["date"] = timeRevised;
                this.items.push(itemObj);
                const graphIndex = this.xAxis.findIndex(
                  (time) => time == timeRevised
                );
                const tableIndex = this.forecastTableData.findIndex(
                  (item) => item.time == timeRevised
                );
                this.$set(
                  this.forecastTableData[tableIndex],
                  "forecast",
                  this.revisedGen[timeRevised]
                );
                this.$set(
                  this.series[1].data,
                  graphIndex,
                  this.revisedGen[timeRevised]
                );
              });
              this.newRevisionId = `R-${parseInt(revisionNo) + 1}`;
              this.revisedGen = {};
              this.reason = "";
              this.remarks = "";
              this.dialog = false;
            }
            this.SET_PROGRESS_BAR(false);
          } catch (error) {
            console.log(error, "ERROR");
            this.SET_PROGRESS_BAR(false);
          }
        } else {
          let payload = {
            icon: "error",
            header: "",
            message: "Forecasted Generation is not edited!",
          };
          this.SET_SNACKBAR_CONTENT(payload);
          this.SET_SHOW_SNACKBAR(true);
        }
      }
    },
    async download() {
      const param = {
        plantId: this.getSelectedPlantId,
        plantName: this.getPlantName(this.getSelectedPlantId),
        fromDate: this.dateFrom,
        toDate: this.dateTo,
        model: this.graphModel
      };
      let encoded = btoa(JSON.stringify(param));
      this.SET_PROGRESS_BAR(true);
      await ForecastService.download(encoded);
      this.SET_PROGRESS_BAR(false);
    },
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    "activeFilter.selectedRange.text"() {
      if (this.activeFilter.selectedRange.text === "Custom") {
        this.dateFrom = this.activeFilter.Date.from
        this.dateTo = this.activeFilter.Date.to
        this.dateInfo = `${this.dateFrom} - ${this.dateTo}`;
      } else {
        const param = this.computeParam();
        this.dateInfo = `${this.activeFilter.selectedRange.text}`;
        this.dateFrom = param.from;
        this.dateTo = param.to;
      }
    },
    async activeWatch(val, oldVal) {
      if (this.enableWatch && !oldVal.includes("null")) {
        this.SET_PROGRESS_BAR(true);
        await Promise.all([
          this.revisionCardHandler(),
          this.lineGraphHandler(),
          this.deviationGraphHandler(),
          this.penaltyVsGenHandler(),
          this.summaryHandler(),
        ]);
        this.SET_PROGRESS_BAR(false);
      }
    },
    watchDates(val, oldVal) {
      if (
        this.activeFilter.selectedRange.text === "Custom" &&
        oldVal !== null
      ) {
        this.dateFrom = val.split(" ")[0];
        this.dateTo = val.split(" ")[1];
      }
    },
    async getSelectedPlantId() {
      if (this.enableWatch) {
        this.SET_PROGRESS_BAR(true);
        await this.setIntervalWithoutDelay(this.initialCall, 3600000);
        this.SET_PROGRESS_BAR(false);
      }
    },
    currentLanguage() {
      this.yAxis[0].name = this.$t("Generation (kWh)");
      if (this.series.length > 0) {
        this.$set(this.series[0], "name", this.$t("Actual"));
        this.$set(this.series[1], "name", this.$t("Forecasted"));
      }
    },
    graphModel() {
      if (!this.enableWatch) return;
      this.lineGraphHandler();
      this.totalGenHandler();
      this.summaryHandler();
      this.deviationGraphHandler();
    }
  },
};
</script>

<style scoped>
.fc-root {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
}

.fc-row {
  display: flex;
  gap: 10px;
  width: 100%;
}

.fc-row--kpi {
  align-items: stretch;
}

.fc-row--kpi>* {
  flex: 1 1 0;
  min-width: 0;
}

.fc-kpi-large {
  flex: 1.5 1 0 !important;
}

.fc-kpi-small {
  flex: 0.75 1 0 !important;
}

.fc-cond-value-large {
  font-size: 24px;
  font-weight: 700;
  margin-top: 8px;
  text-align: center;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.fc-gen-value-large {
  font-size: 24px;
  font-weight: 700;
  margin-top: 8px;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.fc-gen-unit-large {
  font-size: 14px;
  margin-left: 6px;
  font-weight: 500;
}

.fc-row--charts {
  align-items: stretch;
}

.fc-chart-card {
  flex: 7 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.fc-donut-card {
  flex: 3 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.fc-row--bottom {
  align-items: stretch;
}

.fc-bottom-card {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.fc-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 14px 16px 10px;
  gap: 8px;
  flex-wrap: wrap;
}

.fc-card-title {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;
}

.fc-card-subtitle {
  font-size: 11px;
  margin-top: 2px;
}

.fc-card-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.fc-premium-card-header {
  align-items: center;
}

.fc-premium-card-header .fc-card-controls {
  align-items: center;
  gap: 10px;
}

.fc-kpi-card {
  border-radius: 10px;
}

.fc-kpi-body {
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
}

.fc-kpi-section-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.fc-kpi-card:not(.fc-kpi-large) .fc-kpi-section-label {
  justify-content: center;
}

.fc-wx-main {
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  width: 100%;
}

.fc-wx-main>div {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fc-weather-img {
  width: 52px;
  height: 52px;
  object-fit: contain;
  flex-shrink: 0;
  justify-self: center;
}

.fc-wx-temp {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.fc-wx-cond {
  font-size: 12px;
  margin-top: 4px;
  text-transform: capitalize;
}

.fc-cond-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 12px;
}

.fc-cond-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.fc-cond-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.fc-cond-value {
  font-size: 14px;
  font-weight: 700;
}

.fc-gen-pair {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.fc-gen-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.fc-gen-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.fc-gen-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.fc-gen-unit {
  font-size: 11px;
  font-weight: 500;
}

.fc-gen-divider {
  height: 1px;
  background: var(--v-roomRow-base);
  margin: 2px 0;
}

.fc-pen-grid {
  display: flex;
  gap: 0;
  flex: 1;
}

.fc-pen-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-align: center;
  padding: 0 6px;
  border-right: 1px solid var(--v-blockCard-base);
}

.fc-pen-item:last-child {
  border-right: none;
}

.fc-pen-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.fc-pen-value {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.fc-pen-unit {
  font-size: 10px;
  font-weight: 500;
}

.fc-pen-trend {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 18px;
  font-weight: 700;
}

.fc-graph-body,
.fc-table-body,
.fc-pie-body,
.fc-rev-list {
  flex: none;
  height: 55vh;
  min-height: 400px;
  overflow: hidden;
  position: relative;
}

.fc-graph-body {
  padding: 0 12px 12px 0;
  display: flex;
}

.fc-graph {
  width: 100%;
  height: 100% !important;
  margin: 0;
}

.fc-table-body {
  padding: 0 12px 12px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.fc-premium-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  margin: 16px;
  background: var(--v-blockCard-base);
  border-radius: 12px;
  box-shadow: 0 4px 20px transparent;
}

.fc-empty-icon-wrapper {
  color: var(--v-cardBorder-base);
  margin-bottom: 12px;
}

.fc-empty-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--v-lightText-base);
  margin-bottom: 4px;
}

.fc-empty-subtitle {
  font-size: 12px;
  color: var(--v-secondary-base);
  text-align: center;
}

.fc-model-select {
  min-width: 130px;
  max-width: 160px;
  margin-top: 0;
  padding-top: 0;
}

.fc-premium-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.fc-controls-divider {
  width: 1px;
  height: 24px;
  background: var(--v-roomRow-base);
}

.fc-model-select :deep(.v-input__slot) {
  border-radius: 6px !important;
  border: 1px solid var(--v-cardBorder-base) !important;
  background: var(--v-roomRow-base) !important;
  min-height: 36px !important;
  box-shadow: none !important;
  padding: 0 8px 0 12px !important;
}

.fc-model-select :deep(.v-input__slot::before),
.fc-model-select :deep(.v-input__slot::after),
.fc-model-select :deep(fieldset) {
  display: none !important;
}

.fc-model-select :deep(.v-select__selection) {
  white-space: nowrap !important;
}

.fc-model-select :deep(input) {
  font-size: 13px;
  font-weight: 500;
  color: var(--v-primaryText-base) !important;
}

.fc-custom-toggle {
  border-radius: 6px;
  border: 1px solid var(--v-cardBorder-base);
  background: var(--v-blockCard-base);
  overflow: hidden;
  height: 36px;
  display: flex;
  align-items: center;
  padding: 2px;
}

.fc-custom-toggle .fc-toggle-btn {
  height: 30px !important;
  border-radius: 4px;
  margin: 0;
  text-transform: none;
  font-weight: 500;
  border: 1px solid transparent !important;
}

.theme--dark .fc-custom-toggle .fc-toggle-btn {
  color: var(--v-lightText-base) !important;
  background: transparent !important;
}

.theme--light .fc-custom-toggle .fc-toggle-btn {
  color: transparent !important;
  background: transparent !important;
}

.theme--dark .fc-custom-toggle .fc-toggle-btn.v-btn--active {
  color: var(--v-primaryText-base) !important;
  background: var(--v-activeButton-base) !important;
  border: 1px solid var(--v-number-base) !important;
}

.theme--light .fc-custom-toggle .fc-toggle-btn.v-btn--active {
  color: var(--v-primary-base) !important;
  background: var(--v-primaryText-base) !important;
  border: 1px solid var(--v-number-base) !important;
  box-shadow: 0 1px 3px transparent;
}

.fc-custom-toggle .fc-toggle-btn.v-btn--active .v-icon {
  color: var(--v-number-base) !important;
}

.fc-model-select {
  width: 150px;
}

.fc-model-select :deep(fieldset) {
  border-radius: 8px !important;
  border-color: var(--v-cardBorder-base) !important;
}

.fc-model-select :deep(.v-input__slot) {
  min-height: 36px !important;
}

.fc-model-select :deep(.v-select__selection) {
  font-weight: 500;
}

.fc-pie-body {
  padding: 0 8px 12px;
  display: flex;
}

.fc-pie-graph {
  width: 100%;
  height: 100% !important;
}

.fc-rev-list {
  padding: 0 10px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
}

.fc-rev-item {
  border-radius: 8px;
  padding: 10px 12px;
}

.fc-rev-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.fc-rev-date {
  font-size: 10px;
}

.fc-rev-body {
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.fc-table-download-btn {
  position: absolute;
  top: 4px;
  right: 16px;
  height: 40px;
  display: flex;
  align-items: center;
  z-index: 2;
}

.fc-table-download-btn>* {
  margin: 0 !important;
}

.fc-table {
  width: 100%;
  border-collapse: collapse;
  padding: 0 4px;
}

.fc-table th {
  padding: 8px 14px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-bottom: 1px solid var(--v-roomRow-base);
  text-align: center;
}

.fc-table th:first-child {
  text-align: left;
}

.fc-table td {
  padding: 9px 14px;
  font-size: 13px;
  font-weight: 600;
  border-bottom: 1px solid var(--v-blockCard-base);
  text-align: center;
  vertical-align: middle;
}

.fc-table td:first-child {
  text-align: left;
  font-size: 12px;
  font-weight: 500;
}

.fc-trend-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.fc-empty {
  padding: 24px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}

.scada-toggle-height {
  height: 36px;
}

.scada-btn-font {
  font-size: 13px;
}

.scada-title {
  font-size: 20px;
}

.dataTableInputWidth {
  margin: auto;
  width: 80px;
}

.header {
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid var(--v-secondary-base);
}

@media (max-width: 1366px) {
  .fc-row--kpi {
    flex-wrap: wrap;
  }

  .fc-row--kpi>* {
    flex: 1 1 calc(50% - 5px);
  }

  .fc-row--charts {
    flex-wrap: wrap;
  }

  .fc-chart-card {
    flex: 1 1 100%;
  }

  .fc-donut-card {
    flex: 1 1 100%;
  }

  .fc-graph {
    height: 32vh;
  }

  .fc-pie-graph {
    height: 28vh;
  }
}

@media (min-height: 600px) and (max-height: 768px) {
  .fc-graph {
    height: 30vh;
    min-height: 220px;
  }

  .fc-pie-graph {
    height: 25vh;
    min-height: 180px;
  }

  .fc-wx-temp {
    font-size: 22px;
  }

  .fc-pen-value,
  .fc-gen-value {
    font-size: 18px;
  }
}
</style>
<style>
.header .v-table__overflow {
  overflow: unset;
}

table.v-table thead tr {
  height: 38px;
}

.fc-premium-dialog {
  border-radius: 8px !important;
  border: 1px solid var(--v-roomRow-base);
  box-shadow: 0 10px 30px transparent !important;
}

.fc-dialog-card {
  background-color: var(--v-primary-base) !important;
}

.fc-dialog-header {
  padding: 24px 24px 16px 24px;
}

.fc-dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--v-primaryText-base);
  letter-spacing: 0.5px;
}

.fc-dialog-close {
  color: var(--v-secondary-base) !important;
}

.fc-dialog-content {
  padding: 0 24px;
}

.fc-dialog-inputs {
  margin-bottom: 24px;
}

.fc-input-label {
  font-size: 11px;
  color: var(--v-lightText-base);
  margin-bottom: 6px;
  font-weight: 500;
  letter-spacing: 1px;
}

.fc-input-field :deep(.v-input__slot) {
  background: transparent !important;
  border-color: var(--v-cardBorder-base) !important;
  min-height: 38px !important;
  border-radius: 6px;
}

.fc-input-field :deep(.v-input__slot:hover),
.fc-input-field :deep(.v-input__slot.v-input--is-focused) {
  border-color: var(--v-number-base) !important;
}

.fc-input-field :deep(input),
.fc-input-field :deep(.v-select__selection) {
  color: var(--v-primaryText-base) !important;
  font-size: 14px;
}

.fc-disabled-input :deep(.v-input__slot) {
  background: var(--v-blockCard-base) !important;
  border-color: var(--v-roomRow-base) !important;
}

.fc-disabled-input :deep(input) {
  color: var(--v-lightText-base) !important;
  font-weight: 600;
}

.fc-dialog-table-wrapper {
  border: 1px solid var(--v-roomRow-base);
  border-radius: 6px;
  overflow-y: auto;
  max-height: 350px;
  background-color: transparent;
}

.fc-dialog-table {
  width: 100%;
  border-collapse: collapse;
}

.fc-dialog-table th {
  font-size: 11px;
  color: var(--v-lightText-base);
  font-weight: 500;
  letter-spacing: 0.5px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--v-roomRow-base);
  position: sticky;
  top: 0;
  background-color: var(--v-primary-base);
  z-index: 1;
}

.fc-dialog-table td {
  padding: 10px 16px;
  border-bottom: 1px solid var(--v-blockCard-base);
  font-size: 13px;
  color: var(--v-primaryText-base);
}

.fc-dialog-table tbody tr:hover {
  background-color: var(--v-blockCard-base);
}

.text-muted {
  color: var(--v-lightText-base) !important;

  font-size: 14px !important;
}

.fc-table-input {
  width: 100px;
  margin: 0 auto;
}

.fc-table-input :deep(.v-input__slot) {
  background: transparent !important;
  border-color: var(--v-cardBorder-base) !important;
  min-height: 32px !important;
  border-radius: 4px;
}

.fc-table-input :deep(input) {
  text-align: center;
  color: var(--v-primaryText-base) !important;
  font-size: 13px;
}

.fc-dialog-actions {
  padding: 20px 24px 24px;
}

.fc-btn-cancel {
  border: 1px solid var(--v-roomRow-base) !important;
  background: transparent !important;
  color: var(--v-lightText-base) !important;
  text-transform: none;
  font-weight: 500;
  border-radius: 6px;
  height: 38px !important;
  padding: 0 20px !important;
}

.fc-btn-submit {
  border: 1px solid var(--v-number-base) !important;
  background: var(--v-blockCard-base) !important;
  color: var(--v-number-base) !important;
  text-transform: none;
  font-weight: 600;
  border-radius: 6px;
  height: 38px !important;
  padding: 0 24px !important;
}

.fc-fab-premium {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15) !important;
  transition: transform 0.2s ease;
}

.fc-fab-premium:hover {
  transform: scale(1.05);
}
</style>
<style>
.fc-model-dropdown-menu {
  border-radius: 8px !important;
  box-shadow: 0px 8px 24px transparent !important;
  overflow: hidden !important;
}

.fc-model-dropdown-menu .v-list {
  padding: 8px !important;
}

.fc-model-dropdown-menu .v-list-item {
  margin: 0 0 4px 0 !important;
  padding: 10px 16px !important;
  border-radius: 6px !important;
  min-height: 40px !important;
  transition: all 0.2s ease;
}

.fc-model-dropdown-menu .v-list-item:last-child {
  margin-bottom: 0 !important;
}

.fc-model-dropdown-menu .v-list-item--active {
  position: relative;
}

.fc-model-dropdown-menu .v-list-item--active::after {
  content: "";
  position: absolute;
  left: 0;
  top: 15%;
  bottom: 15%;
  width: 3px;
  background-color: var(--v-number-base) !important;
  border-radius: 2px;
}

.fc-premium-v-table {
  border-radius: 8px !important;
  border: 1px solid var(--v-cardBorder-base) !important;
  background: transparent !important;
  box-shadow: none !important;
}

.fc-premium-v-table :deep(th) {
  background: var(--v-blockCard-base) !important;
  font-weight: 700 !important;
  border-bottom: 1px solid var(--v-cardBorder-base) !important;
  height: 48px !important;
  font-size: 11px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-primaryText-base) !important;
  padding: 0 16px !important;
  text-align: left !important;
}

.fc-premium-v-table tr {
  transition: background 0.2s ease;
}

.fc-premium-v-table tr:hover {
  background: var(--v-blockCard-base) !important;
}

.fc-premium-v-table td {
  border-bottom: 1px solid var(--v-roomRow-base) !important;
  font-size: 13px;
  padding: 12px 16px !important;
  text-align: left !important;
}

.fc-premium-table-body {
  position: relative;
  padding: 0 4px;
}
</style>
